import { tradingDocumentFileFactory } from "api/trading-documents/calls";
import { TradingDocument } from "api/trading-documents/models";
import { useDownloadFeedbackToastr } from "components/utils/downloadFeedback/DownloadFeedbackController";
import { fileDownloader } from "fileDownloader";

export const handleDownloadOrderXml = async (
  tradingDocument: TradingDocument,
  downloadFeedbackToastr: ReturnType<typeof useDownloadFeedbackToastr>,
) => {
  if (!tradingDocument) throw new Error("An error occurred");
  const tstr = downloadFeedbackToastr.open({ type: "xml", calculateProgress: false });
  const { url, name } = tradingDocumentFileFactory.tradingDocumentXml(tradingDocument);
  const response = await fileDownloader({
    url,
    name,
    type: "xml",
  });
  if (response.status === "success") {
    tstr.lazyClose();
  }
};
